// extracted by mini-css-extract-plugin
module.exports = {"wrapperBreadcrumbs":"_1xfI2EaXkiMOBcyej-umvz","linkWrapper":"_3W_Zv7kltosJLT3UCD-zcA","separator":"_2rKCbxSEuslzd1u0A5FCfe"};